export default "__VITE_ASSET__CmlXBknF__"